import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { startCase } from 'lodash';

import HeaderPrimary from '@components/HeaderPrimary';

const ThankYouBetaPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderPrimary />
      <Card className="text-center">
        <Card.Body>
          <Card.Title>{startCase(t('thankYouBeta.title'))}</Card.Title>
          <Card.Text>{t('thankYouBeta.description')}</Card.Text>
          <Card.Link as={Link} to="/">{t('common:goHome')}</Card.Link>
        </Card.Body>
      </Card>
    </>
  );
};

export { ThankYouBetaPage };
